import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { getDefaultRedirectPath } from '../utils/routeUtils';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectIfAuthenticated?: boolean;
  redirectPath?: string;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectIfAuthenticated = true,
  redirectPath
}) => {
  const { isAuthenticated, loading, userRole } = useAuthStore();
  const location = useLocation();

  // Don't redirect during loading state to prevent flashing
  if (loading) {
    return <>{children}</>;
  }

  // 若由于凭证过期带着 reason=expired 跳转到登录页，则不做二次重定向
  const reason = new URLSearchParams(location.search).get('reason');
  if (location.pathname === '/login' && reason === 'expired') {
    return <>{children}</>;
  }

  // If user is authenticated and this is a login-type page, redirect to dashboard
  if (isAuthenticated && redirectIfAuthenticated && location.pathname === '/login') {
    const defaultPath = redirectPath || getDefaultRedirectPath(userRole);
    const from = location.state?.from || defaultPath;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
